module.exports = __webpack_public_path__ + "img/scrum-workflow.8455f542.png";